import React from 'react';
import wrapper from '../../assets/images/auth-wrapper.png';
import { useScreenDetector } from '../../hooks/useScreenDetector';

type Props = {
    children: React.ReactNode;
};

const Wrapper = ({ children }: Props) => {
    const { isDesktop } = useScreenDetector();

    return (
        <div className="row g-0">
            <div className="col-md-5">{children}</div>
            {isDesktop && (
                <div className="col-md-7">
                    <img
                        src={wrapper}
                        alt="Login"
                        className="img-fluid"
                        style={{
                            height: '100vh',
                            width: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center'
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default Wrapper;
